module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user-edit"
  }, [_c('n3-form', {
    ref: "form",
    attrs: {
      "validate": ""
    }
  }, [_c('n3-form-item', {
    attrs: {
      "label": "用户名",
      "need": "",
      "label-col": 3
    }
  }, [_c('n3-input', {
    attrs: {
      "rules": [{
        type: 'required'
      }],
      "width": "320px",
      "custom-validate": _vm.usernameValidate
    },
    model: {
      value: (_vm.model.username),
      callback: function($$v) {
        _vm.model.username = $$v
      },
      expression: "model.username"
    }
  })], 1), _vm._v(" "), _c('n3-form-item', {
    attrs: {
      "label": "密码",
      "need": "",
      "label-col": 3
    }
  }, [_c('n3-input', {
    staticClass: "fl",
    attrs: {
      "width": "320px",
      "rules": [{
        type: 'required'
      }],
      "custom-validate": _vm.passwordValidate
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.model.password = $$v
      },
      expression: "model.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "i-tips"
  }, [_c('n3-tooltip', {
    attrs: {
      "content": "随机生成",
      "placement": "top",
      "trigger": "hover"
    }
  }, [_c('n3-icon', {
    staticClass: "refresh",
    attrs: {
      "type": "refresh"
    },
    nativeOn: {
      "click": function($event) {
        _vm.randomPasswd($event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('n3-form-item', {
    attrs: {
      "label": "手机号",
      "need": "",
      "label-col": 3
    }
  }, [_c('n3-input', {
    attrs: {
      "rules": [{
        type: 'required'
      }],
      "custom-validate": _vm.phoneValidate,
      "width": "320px",
      "type": "number"
    },
    model: {
      value: (_vm.model.phone),
      callback: function($$v) {
        _vm.model.phone = $$v
      },
      expression: "model.phone"
    }
  })], 1), _vm._v(" "), _c('n3-form-item', {
    attrs: {
      "label": "优先级",
      "need": "",
      "label-col": 3
    }
  }, [_c('n3-input', {
    staticClass: "fl",
    attrs: {
      "rules": [{
        type: 'required'
      }],
      "width": "320px"
    },
    model: {
      value: (_vm.model.priority),
      callback: function($$v) {
        _vm.model.priority = $$v
      },
      expression: "model.priority"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "i-tips"
  }, [_vm._v("\n        默认 1\n      ")])], 1), _vm._v(" "), _c('n3-form-item', {
    attrs: {
      "label": "次数限制",
      "need": "",
      "label-col": 3
    }
  }, [_c('n3-select', {
    model: {
      value: (_vm.model.limitType),
      callback: function($$v) {
        _vm.model.limitType = $$v
      },
      expression: "model.limitType"
    }
  }, [_c('n3-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("套餐A")]), _vm._v(" "), _c('n3-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("套餐B")])], 1)], 1), _vm._v(" "), _c('n3-form-item', {
    attrs: {
      "label": "过期时间",
      "need": "",
      "label-col": 3
    }
  }, [_c('n3-datepicker', {
    staticClass: "fl",
    attrs: {
      "rules": [{
        type: 'required'
      }],
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.model.expireDate),
      callback: function($$v) {
        _vm.model.expireDate = $$v
      },
      expression: "model.expireDate"
    }
  })], 1), _vm._v(" "), _c('n3-form-item', {
    attrs: {
      "label-col": 3
    }
  }, [_c('n3-button', {
    staticClass: "submit-btn",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loading ? '操作中' : '保存') + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-264cc2c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/form/index.vue
// module id = 304
// module chunks = 3